import { isAuthPath } from "./authPath";
import { broadcastLogout } from "./authBroadcast";
import { clearReturnPath, removeTokens, saveReturnPath } from "./cacheStorage";

interface EndSessionOptions {
  // Session ended by expiry: remember the current page so the user returns after signing in.
  expired?: boolean;
  // Sign out the other tabs too. Only an explicit sign-out should do this; expiry must not,
  // otherwise one tab losing a refresh race signs out the tab that won it.
  broadcast?: boolean;
  // Hard-navigate to the sign-in page.
  redirect?: boolean;
}

// The single place that ends a session locally, so the sign-out paths cannot drift apart.
export const endSession = ({ expired = false, broadcast = false, redirect = false }: EndSessionOptions = {}) => {
  const { pathname, search } = window.location;
  if (expired) {
    if (!isAuthPath(pathname)) saveReturnPath(pathname + search);
  } else {
    clearReturnPath();
  }
  try {
    removeTokens();
    if (broadcast) broadcastLogout();
  } finally {
    if (redirect && !isAuthPath(pathname)) {
      window.location.replace("/auth");
    }
  }
};
